/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsageRouteImport } from './routes/usage'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PairRouteImport } from './routes/pair'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as CanvasCaptureRouteImport } from './routes/canvas-capture'
import { Route as ChatRouteImport } from './routes/_chat'
import { Route as ChatIndexRouteImport } from './routes/_chat.index'
import { Route as SettingsWorldRouteImport } from './routes/settings.world'
import { Route as SettingsToolsRouteImport } from './routes/settings.tools'
import { Route as SettingsSubscriptionAccountsRouteImport } from './routes/settings.subscription-accounts'
import { Route as SettingsProvidersRouteImport } from './routes/settings.providers'
import { Route as SettingsProviderKeysRouteImport } from './routes/settings.provider-keys'
import { Route as SettingsPrivacyRouteImport } from './routes/settings.privacy'
import { Route as SettingsPermissionsRouteImport } from './routes/settings.permissions'
import { Route as SettingsNeucleosAccessRouteImport } from './routes/settings.neucleos-access'
import { Route as SettingsLocalModelsRouteImport } from './routes/settings.local-models'
import { Route as SettingsKeybindingsRouteImport } from './routes/settings.keybindings'
import { Route as SettingsInstructionsRouteImport } from './routes/settings.instructions'
import { Route as SettingsGeneralRouteImport } from './routes/settings.general'
import { Route as SettingsDiagnosticsRouteImport } from './routes/settings.diagnostics'
import { Route as SettingsConnectorsRouteImport } from './routes/settings.connectors'
import { Route as SettingsConnectionsRouteImport } from './routes/settings.connections'
import { Route as SettingsArchivedRouteImport } from './routes/settings.archived'
import { Route as SettingsAppearanceRouteImport } from './routes/settings.appearance'
import { Route as SettingsAccountRouteImport } from './routes/settings.account'
import { Route as ProjectsProjectKeyRouteImport } from './routes/projects.$projectKey'
import { Route as ConnectCallbackRouteImport } from './routes/connect_.callback'
import { Route as ChatSessionSessionIdRouteImport } from './routes/_chat.session.$sessionId'
import { Route as ChatDraftDraftIdRouteImport } from './routes/_chat.draft.$draftId'
import { Route as ChatEnvironmentIdThreadIdRouteImport } from './routes/_chat.$environmentId.$threadId'

const UsageRoute = UsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PairRoute = PairRouteImport.update({
  id: '/pair',
  path: '/pair',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const CanvasCaptureRoute = CanvasCaptureRouteImport.update({
  id: '/canvas-capture',
  path: '/canvas-capture',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/_chat',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatRoute,
} as any)
const SettingsWorldRoute = SettingsWorldRouteImport.update({
  id: '/world',
  path: '/world',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsToolsRoute = SettingsToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSubscriptionAccountsRoute =
  SettingsSubscriptionAccountsRouteImport.update({
    id: '/subscription-accounts',
    path: '/subscription-accounts',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsProvidersRoute = SettingsProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProviderKeysRoute = SettingsProviderKeysRouteImport.update({
  id: '/provider-keys',
  path: '/provider-keys',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsPrivacyRoute = SettingsPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsPermissionsRoute = SettingsPermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsNeucleosAccessRoute = SettingsNeucleosAccessRouteImport.update({
  id: '/neucleos-access',
  path: '/neucleos-access',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsLocalModelsRoute = SettingsLocalModelsRouteImport.update({
  id: '/local-models',
  path: '/local-models',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsKeybindingsRoute = SettingsKeybindingsRouteImport.update({
  id: '/keybindings',
  path: '/keybindings',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsInstructionsRoute = SettingsInstructionsRouteImport.update({
  id: '/instructions',
  path: '/instructions',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDiagnosticsRoute = SettingsDiagnosticsRouteImport.update({
  id: '/diagnostics',
  path: '/diagnostics',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsConnectorsRoute = SettingsConnectorsRouteImport.update({
  id: '/connectors',
  path: '/connectors',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsConnectionsRoute = SettingsConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsArchivedRoute = SettingsArchivedRouteImport.update({
  id: '/archived',
  path: '/archived',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SettingsRoute,
} as any)
const ProjectsProjectKeyRoute = ProjectsProjectKeyRouteImport.update({
  id: '/projects/$projectKey',
  path: '/projects/$projectKey',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectCallbackRoute = ConnectCallbackRouteImport.update({
  id: '/connect_/callback',
  path: '/connect/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatSessionSessionIdRoute = ChatSessionSessionIdRouteImport.update({
  id: '/session/$sessionId',
  path: '/session/$sessionId',
  getParentRoute: () => ChatRoute,
} as any)
const ChatDraftDraftIdRoute = ChatDraftDraftIdRouteImport.update({
  id: '/draft/$draftId',
  path: '/draft/$draftId',
  getParentRoute: () => ChatRoute,
} as any)
const ChatEnvironmentIdThreadIdRoute =
  ChatEnvironmentIdThreadIdRouteImport.update({
    id: '/$environmentId/$threadId',
    path: '/$environmentId/$threadId',
    getParentRoute: () => ChatRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ChatIndexRoute
  '/canvas-capture': typeof CanvasCaptureRoute
  '/connect': typeof ConnectRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/connect/callback': typeof ConnectCallbackRoute
  '/projects/$projectKey': typeof ProjectsProjectKeyRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/connectors': typeof SettingsConnectorsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/instructions': typeof SettingsInstructionsRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/local-models': typeof SettingsLocalModelsRoute
  '/settings/neucleos-access': typeof SettingsNeucleosAccessRoute
  '/settings/permissions': typeof SettingsPermissionsRoute
  '/settings/privacy': typeof SettingsPrivacyRoute
  '/settings/provider-keys': typeof SettingsProviderKeysRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/subscription-accounts': typeof SettingsSubscriptionAccountsRoute
  '/settings/tools': typeof SettingsToolsRoute
  '/settings/world': typeof SettingsWorldRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/session/$sessionId': typeof ChatSessionSessionIdRoute
}
export interface FileRoutesByTo {
  '/canvas-capture': typeof CanvasCaptureRoute
  '/connect': typeof ConnectRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/connect/callback': typeof ConnectCallbackRoute
  '/projects/$projectKey': typeof ProjectsProjectKeyRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/connectors': typeof SettingsConnectorsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/instructions': typeof SettingsInstructionsRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/local-models': typeof SettingsLocalModelsRoute
  '/settings/neucleos-access': typeof SettingsNeucleosAccessRoute
  '/settings/permissions': typeof SettingsPermissionsRoute
  '/settings/privacy': typeof SettingsPrivacyRoute
  '/settings/provider-keys': typeof SettingsProviderKeysRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/subscription-accounts': typeof SettingsSubscriptionAccountsRoute
  '/settings/tools': typeof SettingsToolsRoute
  '/settings/world': typeof SettingsWorldRoute
  '/': typeof ChatIndexRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/session/$sessionId': typeof ChatSessionSessionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_chat': typeof ChatRouteWithChildren
  '/canvas-capture': typeof CanvasCaptureRoute
  '/connect': typeof ConnectRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/connect_/callback': typeof ConnectCallbackRoute
  '/projects/$projectKey': typeof ProjectsProjectKeyRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/connectors': typeof SettingsConnectorsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/instructions': typeof SettingsInstructionsRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/local-models': typeof SettingsLocalModelsRoute
  '/settings/neucleos-access': typeof SettingsNeucleosAccessRoute
  '/settings/permissions': typeof SettingsPermissionsRoute
  '/settings/privacy': typeof SettingsPrivacyRoute
  '/settings/provider-keys': typeof SettingsProviderKeysRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/subscription-accounts': typeof SettingsSubscriptionAccountsRoute
  '/settings/tools': typeof SettingsToolsRoute
  '/settings/world': typeof SettingsWorldRoute
  '/_chat/': typeof ChatIndexRoute
  '/_chat/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/_chat/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/_chat/session/$sessionId': typeof ChatSessionSessionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/canvas-capture'
    | '/connect'
    | '/pair'
    | '/settings'
    | '/usage'
    | '/connect/callback'
    | '/projects/$projectKey'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/connections'
    | '/settings/connectors'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/instructions'
    | '/settings/keybindings'
    | '/settings/local-models'
    | '/settings/neucleos-access'
    | '/settings/permissions'
    | '/settings/privacy'
    | '/settings/provider-keys'
    | '/settings/providers'
    | '/settings/subscription-accounts'
    | '/settings/tools'
    | '/settings/world'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
    | '/session/$sessionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/canvas-capture'
    | '/connect'
    | '/pair'
    | '/settings'
    | '/usage'
    | '/connect/callback'
    | '/projects/$projectKey'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/connections'
    | '/settings/connectors'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/instructions'
    | '/settings/keybindings'
    | '/settings/local-models'
    | '/settings/neucleos-access'
    | '/settings/permissions'
    | '/settings/privacy'
    | '/settings/provider-keys'
    | '/settings/providers'
    | '/settings/subscription-accounts'
    | '/settings/tools'
    | '/settings/world'
    | '/'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
    | '/session/$sessionId'
  id:
    | '__root__'
    | '/_chat'
    | '/canvas-capture'
    | '/connect'
    | '/pair'
    | '/settings'
    | '/usage'
    | '/connect_/callback'
    | '/projects/$projectKey'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/connections'
    | '/settings/connectors'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/instructions'
    | '/settings/keybindings'
    | '/settings/local-models'
    | '/settings/neucleos-access'
    | '/settings/permissions'
    | '/settings/privacy'
    | '/settings/provider-keys'
    | '/settings/providers'
    | '/settings/subscription-accounts'
    | '/settings/tools'
    | '/settings/world'
    | '/_chat/'
    | '/_chat/$environmentId/$threadId'
    | '/_chat/draft/$draftId'
    | '/_chat/session/$sessionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ChatRoute: typeof ChatRouteWithChildren
  CanvasCaptureRoute: typeof CanvasCaptureRoute
  ConnectRoute: typeof ConnectRoute
  PairRoute: typeof PairRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  UsageRoute: typeof UsageRoute
  ConnectCallbackRoute: typeof ConnectCallbackRoute
  ProjectsProjectKeyRoute: typeof ProjectsProjectKeyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/usage': {
      id: '/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pair': {
      id: '/pair'
      path: '/pair'
      fullPath: '/pair'
      preLoaderRoute: typeof PairRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/canvas-capture': {
      id: '/canvas-capture'
      path: '/canvas-capture'
      fullPath: '/canvas-capture'
      preLoaderRoute: typeof CanvasCaptureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat': {
      id: '/_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/': {
      id: '/_chat/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof ChatRoute
    }
    '/settings/world': {
      id: '/settings/world'
      path: '/world'
      fullPath: '/settings/world'
      preLoaderRoute: typeof SettingsWorldRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/tools': {
      id: '/settings/tools'
      path: '/tools'
      fullPath: '/settings/tools'
      preLoaderRoute: typeof SettingsToolsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/subscription-accounts': {
      id: '/settings/subscription-accounts'
      path: '/subscription-accounts'
      fullPath: '/settings/subscription-accounts'
      preLoaderRoute: typeof SettingsSubscriptionAccountsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/providers': {
      id: '/settings/providers'
      path: '/providers'
      fullPath: '/settings/providers'
      preLoaderRoute: typeof SettingsProvidersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/provider-keys': {
      id: '/settings/provider-keys'
      path: '/provider-keys'
      fullPath: '/settings/provider-keys'
      preLoaderRoute: typeof SettingsProviderKeysRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/privacy': {
      id: '/settings/privacy'
      path: '/privacy'
      fullPath: '/settings/privacy'
      preLoaderRoute: typeof SettingsPrivacyRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/permissions': {
      id: '/settings/permissions'
      path: '/permissions'
      fullPath: '/settings/permissions'
      preLoaderRoute: typeof SettingsPermissionsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/neucleos-access': {
      id: '/settings/neucleos-access'
      path: '/neucleos-access'
      fullPath: '/settings/neucleos-access'
      preLoaderRoute: typeof SettingsNeucleosAccessRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/local-models': {
      id: '/settings/local-models'
      path: '/local-models'
      fullPath: '/settings/local-models'
      preLoaderRoute: typeof SettingsLocalModelsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/keybindings': {
      id: '/settings/keybindings'
      path: '/keybindings'
      fullPath: '/settings/keybindings'
      preLoaderRoute: typeof SettingsKeybindingsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/instructions': {
      id: '/settings/instructions'
      path: '/instructions'
      fullPath: '/settings/instructions'
      preLoaderRoute: typeof SettingsInstructionsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/diagnostics': {
      id: '/settings/diagnostics'
      path: '/diagnostics'
      fullPath: '/settings/diagnostics'
      preLoaderRoute: typeof SettingsDiagnosticsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/connectors': {
      id: '/settings/connectors'
      path: '/connectors'
      fullPath: '/settings/connectors'
      preLoaderRoute: typeof SettingsConnectorsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/connections': {
      id: '/settings/connections'
      path: '/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof SettingsConnectionsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/archived': {
      id: '/settings/archived'
      path: '/archived'
      fullPath: '/settings/archived'
      preLoaderRoute: typeof SettingsArchivedRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/projects/$projectKey': {
      id: '/projects/$projectKey'
      path: '/projects/$projectKey'
      fullPath: '/projects/$projectKey'
      preLoaderRoute: typeof ProjectsProjectKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect_/callback': {
      id: '/connect_/callback'
      path: '/connect/callback'
      fullPath: '/connect/callback'
      preLoaderRoute: typeof ConnectCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/session/$sessionId': {
      id: '/_chat/session/$sessionId'
      path: '/session/$sessionId'
      fullPath: '/session/$sessionId'
      preLoaderRoute: typeof ChatSessionSessionIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/draft/$draftId': {
      id: '/_chat/draft/$draftId'
      path: '/draft/$draftId'
      fullPath: '/draft/$draftId'
      preLoaderRoute: typeof ChatDraftDraftIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/$environmentId/$threadId': {
      id: '/_chat/$environmentId/$threadId'
      path: '/$environmentId/$threadId'
      fullPath: '/$environmentId/$threadId'
      preLoaderRoute: typeof ChatEnvironmentIdThreadIdRouteImport
      parentRoute: typeof ChatRoute
    }
  }
}

interface ChatRouteChildren {
  ChatIndexRoute: typeof ChatIndexRoute
  ChatEnvironmentIdThreadIdRoute: typeof ChatEnvironmentIdThreadIdRoute
  ChatDraftDraftIdRoute: typeof ChatDraftDraftIdRoute
  ChatSessionSessionIdRoute: typeof ChatSessionSessionIdRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatIndexRoute: ChatIndexRoute,
  ChatEnvironmentIdThreadIdRoute: ChatEnvironmentIdThreadIdRoute,
  ChatDraftDraftIdRoute: ChatDraftDraftIdRoute,
  ChatSessionSessionIdRoute: ChatSessionSessionIdRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

interface SettingsRouteChildren {
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsArchivedRoute: typeof SettingsArchivedRoute
  SettingsConnectionsRoute: typeof SettingsConnectionsRoute
  SettingsConnectorsRoute: typeof SettingsConnectorsRoute
  SettingsDiagnosticsRoute: typeof SettingsDiagnosticsRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsInstructionsRoute: typeof SettingsInstructionsRoute
  SettingsKeybindingsRoute: typeof SettingsKeybindingsRoute
  SettingsLocalModelsRoute: typeof SettingsLocalModelsRoute
  SettingsNeucleosAccessRoute: typeof SettingsNeucleosAccessRoute
  SettingsPermissionsRoute: typeof SettingsPermissionsRoute
  SettingsPrivacyRoute: typeof SettingsPrivacyRoute
  SettingsProviderKeysRoute: typeof SettingsProviderKeysRoute
  SettingsProvidersRoute: typeof SettingsProvidersRoute
  SettingsSubscriptionAccountsRoute: typeof SettingsSubscriptionAccountsRoute
  SettingsToolsRoute: typeof SettingsToolsRoute
  SettingsWorldRoute: typeof SettingsWorldRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsArchivedRoute: SettingsArchivedRoute,
  SettingsConnectionsRoute: SettingsConnectionsRoute,
  SettingsConnectorsRoute: SettingsConnectorsRoute,
  SettingsDiagnosticsRoute: SettingsDiagnosticsRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsInstructionsRoute: SettingsInstructionsRoute,
  SettingsKeybindingsRoute: SettingsKeybindingsRoute,
  SettingsLocalModelsRoute: SettingsLocalModelsRoute,
  SettingsNeucleosAccessRoute: SettingsNeucleosAccessRoute,
  SettingsPermissionsRoute: SettingsPermissionsRoute,
  SettingsPrivacyRoute: SettingsPrivacyRoute,
  SettingsProviderKeysRoute: SettingsProviderKeysRoute,
  SettingsProvidersRoute: SettingsProvidersRoute,
  SettingsSubscriptionAccountsRoute: SettingsSubscriptionAccountsRoute,
  SettingsToolsRoute: SettingsToolsRoute,
  SettingsWorldRoute: SettingsWorldRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ChatRoute: ChatRouteWithChildren,
  CanvasCaptureRoute: CanvasCaptureRoute,
  ConnectRoute: ConnectRoute,
  PairRoute: PairRoute,
  SettingsRoute: SettingsRouteWithChildren,
  UsageRoute: UsageRoute,
  ConnectCallbackRoute: ConnectCallbackRoute,
  ProjectsProjectKeyRoute: ProjectsProjectKeyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
